import noop from 'lodash/noop'
import React from 'react'
import styled from 'styled-components/native'
import { InputError } from './InputError'
import { TextInput } from './TextInput'
import { CodeInputProps } from './types'

const Wrapper = styled.View``
const Row = styled.View`
  flex-direction: row;
`
const InputWrapper = styled.View`
  width: 50%;
`

export function CodeInput({
  length = 0,
  value,
  onChange = noop,
  onSubmitEditing = noop,
  inputMode,
  enterKeyHint,
  autoFocus = false,
  placeholder,
  error,
  ref,
}: CodeInputProps): React.ReactNode {
  return (
    <Wrapper>
      <Row>
        <InputWrapper>
          <TextInput
            ref={ref}
            maxLength={length}
            onChange={onChange}
            onSubmitEditing={onSubmitEditing}
            inputMode={inputMode}
            value={value}
            autoFocus={autoFocus}
            enterKeyHint={enterKeyHint}
            placeholder={placeholder}
            numberOfLines={1}
            textContentType="oneTimeCode"
          />
        </InputWrapper>
      </Row>
      <InputError error={error} />
    </Wrapper>
  )
}
